import React from 'react'
import View from './view'
import SessionReducer from '../commons/SessionReducer'
import { userInfo } from '../App/selector'
// import FetchRuolo from '../../commons/FetchRuolo'
// <FetchRuolo>  </FetchRuolo>
export class Main extends React.Component {

    render() {
        return <SessionReducer storeTarget={userInfo.target}>
            <View {...this.props} />
        </SessionReducer>
    }
}